import { render, staticRenderFns } from "./ModifyOrderModal.vue?vue&type=template&id=c10857e4&scoped=true&"
import script from "./ModifyOrderModal.vue?vue&type=script&lang=js&"
export * from "./ModifyOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10857e4",
  null
  
)

export default component.exports